import { toRegulatoryDomainFile } from './regulatoryDiagramDomainState';

export const syncRegulatoryFileState = ({
    file,
    dispatch,
    setCurrentDRG,
    normalize = true,
} = {}) => {
    if (!file) {
        if (dispatch && setCurrentDRG) {
            dispatch(setCurrentDRG(undefined));
        }
        localStorage.removeItem('regulatory-file');
        return undefined;
    }

    const nextFile = normalize ? toRegulatoryDomainFile(file) : file;

    if (dispatch && setCurrentDRG) {
        dispatch(setCurrentDRG(nextFile));
    }
    localStorage.setItem('regulatory-file', JSON.stringify(nextFile));

    return nextFile;
};
